import linkedin from "../assets/linkedin.png";
import github from "../assets/github.png";
import instagram from "../assets/instagram.png";
import leetcode from "../assets/leetcodeicon.png";
// import twitter from "../assets/twitter(1).png";
import resume from "../assets/resume-logo.png";

const SocialMediaIcons = () => {
    return (
      <div className="flex justify-center md:justify-start my-10 gap-7">
        <a
          className="hover:opacity-50 transition duration-500"
          href="https://www.linkedin.com/in/gauranshgoel123/"
          target="_blank"
          rel="noreferrer"
        >
          <img title="View Linkedin Profile" alt="linkedin-link" src={linkedin} />
        </a>
        <a
          className="hover:opacity-50 transition duration-500"
          href="https://github.com/Gauranshgoel123"
          target="_blank"
          rel="noreferrer"
        >
          <img title="View Github Profile" alt="github-link" src={github} />
        </a>
         {/* <a
          className="hover:opacity-50 transition duration-500"
          href="https://www.twitter.com"
          target="_blank"
          rel="noreferrer"
        >
          <img title="View Twitter Profile" alt="twitter-link" src={twitter} />
        </a> 
         */}
        <a
          className="hover:opacity-50 transition duration-500"
          href="https://www.instagram.com/gauranshhh_/"
          target="_blank"
          rel="noreferrer"
        >
          <img title="View Instagram Profile" alt="instagram-link" src={instagram}/>
        </a>

          <a
          className="hover:opacity-50 transition duration-500"
          href="https://leetcode.com/gauranshgoel123/"
          target="_blank"
          rel="noreferrer"
        >
          <img className="w-8" title="View Leetcode Profile" alt="leetcode-link" src={leetcode}/>
        </a>

        <a
          className="hover:opacity-50 transition duration-500"
          // href="https://drive.google.com/file/d/1IMmLTHgl9Dkxbr87Rx6YliYZZgu-qxvL/view?usp=sharing"        //this is oldest resume 2023
          // href="https://drive.google.com/file/d/1109QKsOxemT0Wq33uRATzWhuHLlfAKkG/view?usp=sharing"        //latest resume updated 23-06-2025
          // href="https://drive.google.com/file/d/1AG4ypdpivwDFHXAJBxBmwBTy0aSpTFMz/view?usp=sharing"        //updated resume 04-07-2025
          // href="https://drive.google.com/file/d/136lr5UEzc2oe5XzO8oeM-oplPxdusTno/view?usp=sharing"        //updated resume on 05-07-2025
          // href="https://drive.google.com/file/d/1kpElnPZJXDyUEFOxW_KSCXEKS_mXKxXK/view?usp=sharing"        //updated resume on 08-07-2025 after new cgpa\
          // href="https://drive.google.com/file/d/1ObAfdtIR0w3cYtiITkcW8FWT8897qR8T/view?usp=sharing"         //updated resume on 29-09-2025 amazon ml summer schooln
          // href="https://drive.google.com/file/d/14TaWCVTFcriOm-SwmEoMBTrXzjVDCs-_/view?usp=sharing"        //updated amazon as completed
          // href="https://drive.google.com/file/d/1TL2mArDOJDMzDHoJkkK3LQwhbpu-Nc35/view?usp=sharing"           //updated project - posecheck minor 
             href = "https://drive.google.com/file/d/1Jf1ac2xlgbH2zv4iwOcXSedAIL_cvyjv/view?usp=sharing"      // updated resume by fixing the name of uniglobal to unibglobal

          target="_blank"
          rel="noreferrer"
        >
          <img title="View Resume" alt="resume-link" src={resume} />
        </a>
      </div>
    );
  };
  
  export default SocialMediaIcons;